"use client";
import { Button } from "@nextui-org/react";
import Image from "next/image";
import React, { useState, useEffect, useRef } from "react";
import { IoArrowBackOutline, IoArrowForwardOutline } from "react-icons/io5";

const Carousel = ({ images, interval = 3500 }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const intervalRef = useRef(null);

  const resetTimer = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setActiveIndex((current) => (current + 1) % images.length);
    }, interval);
  };

  useEffect(() => {
    resetTimer();
    return () => clearInterval(intervalRef.current);
  }, [images.length, interval]);

  const handlePrev = () => {
    setActiveIndex((current) => (current - 1 + images.length) % images.length);
    resetTimer();
  };

  const handleNext = () => {
    setActiveIndex((current) => (current + 1) % images.length);
    resetTimer();
  };

  return (
    <div className="relative w-full mx-auto px-4 py-8">
      <div className="flex items-center justify-center bg-gray-50 rounded-xl shadow-lg p-6">
        <Button
          onPress={handlePrev}
          variant="light"
          className="absolute left-2 z-10  pr-5 transition-all duration-300"
        >
          <IoArrowBackOutline className="text-2xl text-gray-700" />
        </Button>

        <div className="flex gap-8 overflow-hidden px-4">
          {[0, 1, 2, 3].map((offset) => (
            <div
              key={offset}
              className="relative aspect-[4/3] w-60 max-w-[240px] rounded flex items-center justify-center transition-transform duration-500 hover:scale-105 overflow-hidden"
            >
              <Image
                src={images[(activeIndex + offset) % images.length]}
                alt={`Slide ${offset + 1}`}
                width={240} // Valor fijo de ancho
                height={180} // Relación 4:3
                className="object-contain w-full h-full"
                priority={offset === 0}
                sizes="(max-width: 768px) 100vw, 240px"
              />
            </div>
          ))}
        </div>

        <Button
          onPress={handleNext}
          variant="light"
          className="absolute right-2 z-10 pl-5 transition-all duration-300"
        >
          <IoArrowForwardOutline className="text-2xl text-gray-700" />
        </Button>
      </div>
    </div>
  );
};

export default Carousel;
